import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-067f8e54"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex align-items-center justify-content-between mb-2 flex-wrap gap-2" }
const _hoisted_2 = {
  key: 0,
  class: "text-sm text-orange-500"
}
const _hoisted_3 = {
  key: 0,
  class: "text-sm text-color-secondary"
}
const _hoisted_4 = { class: "coeff-grid mb-3" }
const _hoisted_5 = { class: "coeff-card" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "kpi-label" }, "Ai", -1))
const _hoisted_7 = { class: "kpi-value" }
const _hoisted_8 = { class: "coeff-card" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "kpi-label" }, "Bi", -1))
const _hoisted_10 = { class: "kpi-value" }
const _hoisted_11 = { class: "coeff-card" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "kpi-label" }, "Ci", -1))
const _hoisted_13 = { class: "kpi-value" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-label mb-2" }, "Pending proposals", -1))
const _hoisted_16 = { class: "detail-list" }
const _hoisted_17 = { class: "text-color-secondary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WSubTitle = _resolveComponent("WSubTitle")!
  const _component_PButton = _resolveComponent("PButton")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_WSubTitle, { text: "Coefficients" }),
      (_ctx.coefficients?.pending_count)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.coefficients.pending_count) + " pending proposal(s) ", 1))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.coefficients)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, "No coefficient data."))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.fmt(_ctx.coefficients.Ai)), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.fmt(_ctx.coefficients.Bi)), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.fmt(_ctx.coefficients.Ci)), 1)
            ])
          ]),
          (_ctx.coefficients.pending_proposals?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("ul", _hoisted_16, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.coefficients.pending_proposals, (p) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: p.id
                    }, [
                      _createElementVNode("strong", null, _toDisplayString(p.target_period || '—'), 1),
                      _createElementVNode("span", _hoisted_17, " · A=" + _toDisplayString(_ctx.fmt(p.ai)) + " B=" + _toDisplayString(_ctx.fmt(p.bi)) + " C=" + _toDisplayString(_ctx.fmt(p.ci)) + " · " + _toDisplayString(p.data_points ?? '—') + " pts · " + _toDisplayString(p.generated_by || '—'), 1)
                    ]))
                  }), 128))
                ]),
                _createVNode(_component_PButton, {
                  class: "mt-1",
                  label: "Open Coefficients",
                  link: "",
                  size: "small",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'coefficients' })))
                })
              ]))
            : _createCommentVNode("", true)
        ], 64))
  ]))
}